import React from "react";
import styled from "styled-components";
import { RDVButton, Inner } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import theme from "../../theme";
import AnimateOnScroll from "../../components/AnimateOnScroll";

const Section = styled.section`
  /*background-color: var(--my-color3);*/
  width: 100%;
  padding: 2rem 0;
  color: white;
`;

const Container = styled(Inner)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 800px;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  margin-top: 1rem;
  color: white;
  font-weight: bold;
`;

const SubtitleSection = styled.p`
  font-size: 1.1rem;
  margin-top: 1rem;
  color: var(--my-color5);
  font-weight: normal;
`;

const TimelineContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 2rem;
  width: 100%;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 2rem;
    left: 0;
    right: 0;
    height: 2px;
    background-color: var(--my-color5);
    z-index: 1;
  }

  ${theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: 2rem;

    &::before {
      display: none;
    }
  }
`;

const TimelineStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  z-index: 2;

  ${theme.breakpoints.down("md")} {
    flex-direction: row;
    text-align: left;
    gap: 1rem;
  }
`;

const StepIcon = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: var(--my-color5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;

  ${theme.breakpoints.down("md")} {
    width: 3rem;
    height: 3rem;
    font-size: 1.2rem;
    margin-bottom: 0;
  }
`;

const StepContent = styled.div`
  text-align: center;
  max-width: 12rem;

  ${theme.breakpoints.down("md")} {
    text-align: left;
    max-width: none;
    flex: 1;
  }
`;

const StepTitle = styled.h3`
  font-size: 1.1rem;
  margin: 0 0 0.5rem 0;
  color: var(--my-color5);
  font-weight: bold;
`;

const StepDuration = styled.div`
  font-size: 0.9rem;
  color: var(--my-color2);
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const StepDescription = styled.p`
  font-size: 0.9rem;
  line-height: 1.3rem;
  margin: 0;
`;

const MicroCopy = styled.p`
  font-size: 0.9rem;
  margin-top: 2rem;
  font-style: italic;
  color: var(--my-color5);
`;

const ButtonWrapper = styled.div`
  margin-top: 2rem;
`;

const ProcessSection = () => {
  const steps = [
    {
      icon: "1",
      title: "Audit express",
      duration: "48h",
      description:
        "Analyse de votre présence actuelle et identification des opportunités d'amélioration.",
    },
    {
      icon: "2",
      title: "Prototype one-page",
      duration: "7 jours",
      description:
        "Landing page optimisée conversion avec vos messages clés et preuves sociales.",
    },
    {
      icon: "3",
      title: "Mise en ligne + contenu",
      duration: "3 semaines",
      description:
        "Site complet + stratégie réseaux sociaux pour humaniser votre image.",
    },
    {
      icon: "4",
      title: "Optimisation continue",
      duration: "En continu",
      description:
        "A/B testing, analytics et améliorations basées sur les données réelles.",
    },
  ];

  return (
    <Section>
      <Container>
        <HighlightTitle
          text="Notre méthode"
          highlightWord="méthode"
          bg="white"
          textColor="var(--my-color3)"
          mainTextColor="white"
        />
        <SubtitleSection style={{ fontStyle: "italic", margin: "0.8rem 0" }}>
          « Arrêtez de perfectionner. Lancez. Convertissez. »
        </SubtitleSection>
        <Subtitle>
          Une méthode agile pour sites web, apps mobiles et logiciels
          SaaS&nbsp;– pendant que nous construisons, VOUS prospectez.
        </Subtitle>
        <TimelineContainer>
          {steps.map((step, index) => (
            <AnimateOnScroll key={index} type="fade">
              <TimelineStep>
                <StepIcon>{step.icon}</StepIcon>
                <StepContent>
                  <StepTitle>{step.title}</StepTitle>
                  <StepDuration>{step.duration}</StepDuration>
                  <StepDescription>{step.description}</StepDescription>
                </StepContent>
              </TimelineStep>
            </AnimateOnScroll>
          ))}
        </TimelineContainer>
        <MicroCopy>
          Un processus qui respecte vos priorités&nbsp;: signer des clients
          d'abord, perfectionner ensuite.
          <br />
          <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
            <span style={{ fontWeight: "bold" }}>Option BOOST&nbsp;</span>:
            après la mise en ligne, nous lançons vos campagnes Ads pour
            accélérer vos conversions.
          </span>
        </MicroCopy>
        <ButtonWrapper>
          <RDVButton label="Démarrer mon audit express" />
        </ButtonWrapper>
      </Container>
    </Section>
  );
};

export default ProcessSection;
